@if (patientService.data) {
  <div
    #demographics
    class="demographics"
    (window:resize)="onResize($event)"
    (window:scroll)="onResize($event)"
  >
    <div class="d-flex flex-row">
      <div class="flex-row align-content-around">
        <div class="d-inline-flex me-5">
          <div class="header fw-bold me-2 text-nowrap">{{ translations.demographics.id }}:</div>
          <div class="d-inline-block text-nowrap">
            {{ patientService.data.nationalId }}
          </div>
        </div>

        <div class="d-inline-flex me-5">
          <div class="header fw-bold me-2 text-nowrap">{{ translations.demographics.name }}:</div>
          <div class="d-inline-block text-nowrap">
            {{ patientService.data.firstname }}
          </div>
        </div>

        <div class="d-inline-flex me-5">
          <div class="header fw-bold me-2 text-nowrap">
            {{ translations.demographics.surname }}:
          </div>
          <div class="d-inline-block text-nowrap">
            {{ patientService.data.lastname }}
          </div>
        </div>

        <div class="d-inline-flex me-5">
          <div class="header fw-bold me-2 text-nowrap">
            {{ translations.demographics.date_of_birth }}:
          </div>
          <div class="d-inline-block text-nowrap">
            {{ patientService.data.dob | date: 'dd-MM-yyyy' }}
          </div>
        </div>

        @if (patientService.data.gender) {
          <div class="d-inline-flex me-5">
            <div class="header fw-bold me-2 text-nowrap">
              {{ translations.demographics.gender }}:
            </div>
            <div class="d-inline-block text-nowrap">
              {{ patientService.data.gender }}
            </div>
          </div>
        }

        <div class="d-inline-flex me-5">
          <div class="header fw-bold me-2 text-nowrap">
            {{ translations.demographics.telephone }}:
          </div>
          <div class="d-inline-block text-nowrap">
            {{patientPhone()}}
          </div>
        </div>
      </div>
      @if (router.url === '/cy/patient/ps' && versions() && versions().length > 0) {
        <div class="flex-row ms-auto">
          <ncp-button
            #editBtn
            [(options)]="editButtonOptions"
          />
        </div>
      } @else if (router.url === '/cy/patient/ps/edit' || router.url === '/cy/patient/ps/create') {
        <div class="d-inline-flex flex-row ms-auto">
          <ncp-button
            #discardBtn
            [(options)]="discardButtonOptions"
          />
          <ncp-button
            #saveBtn
            [(options)]="saveButtonOptions"
          />
        </div>
      } @else if (router.url === '/cy/patient/orcd') {
        <div class="flex-row ms-auto">
          <ncp-button
            #editOrcdBtn
            [(options)]="editOrcdButtonOptions"
          />
        </div>
      } @else if (router.url === '/cy/patient/orcd/create') {
        <div class="d-inline-flex flex-row ms-auto">
          <ncp-button
            #backOrcdBtn
            [(options)]="backOrcdButtonOptions"
          />
        </div>
      }
    </div>
  </div>
}

<ncp-modal
  #mod
  [options]="consentModalOptions()"
>
  {{ consentMessage }}
</ncp-modal>

@if (
  environment.project === PROJECTS.BENEFICIARIES &&
  patientService.data?.patientId &&
  patientService.data?.patientId! < 0
) {
  <div class="flex-grow-1 justify-content-center align-content-center">
    <h5>{{ translations.nodata }}</h5>
  </div>
} @else {
  <router-outlet />
}
